var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HistoryPage"},[_c('backgroundTop',{attrs:{"title":"遵义医科大学附属医院"}}),_c('historyFrom'),_c('CopyRight')],1)}
var staticRenderFns = []

export { render, staticRenderFns }